export default "__VITE_ASSET__Lf5_$PwD__"